export default "__VITE_ASSET__4fa44254__"